// 校验手机号：11 位数字
export function validTelephone (telephone) {
  return /^1\d{10}$/.test(telephone)
}

// 检测form中是否合法 （有空值）
// 注意： {} => true
export function validForm (form) {
  let valid = true
  for (var i in form) {
    if (!form[i]) {
      valid = false
    }
  }
  return valid
}

// 检测密码是否是8-20位之间
export function validPassword (password) {
  return /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,20})$/.test(password)
}

// 校验数字是否合法（只能输入数字，小数点保留两位数，最多填写7位数字，不可以0开头的非小数）
export function validNumber (num) {
  if (isNaN(num)) {
    return '请输入数字'
  }
  if (Number(num) < 0) {
    return '不可以是负数'
  }
  if (/^0\d+/.test(num)) {
    return '不可以是0开头的非小数'
  }
  if (num.indexOf('.') !== -1) { // 是小数
    if (!/\.([0-9]{1,2})$/.test(num)) {
      return '小数点后最多两位'
    }
  }
  if (Number(num) > 9999999) {
    return '不能大于9999999'
  }
  return true
}
